<template>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
        <!-- ============================================================== -->
        <!-- Container fluid  -->
        <!-- ============================================================== -->
        <div class="container-fluid">
            <!-- ============================================================== -->
            <!-- Bread crumb and right sidebar toggle -->
            <!-- ============================================================== -->
            <div class="row page-titles">
                <div class="col-md-5 align-self-center">
                    <h4 class="text-themecolor">Add New Practice</h4>
                </div>
                <div class="col-md-7 align-self-center text-right">
                    <div class="d-flex justify-content-end align-items-center">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="dashboard">Home</a></li>
                            <li class="breadcrumb-item active">Add New Practice</li>
                        </ol>
                    </div>
                </div>
            </div>

            <div class="card p-3">

                <div class="card">
                    <div class="card-body">
                        <form class="floating-labels" novalidate>
                            <h3 class="font-weight-bold h3Spacing">General Information</h3>
                            <div class="form-row">
                                <div class="col-md-6 mb-3">
                                    <select class="form-control custom-select" tabindex="1">
                                        <option value="">Choose Timezone</option>
                                        <option value="">Timezone 01</option>
                                        <option value="">Timezone 02</option>
                                        <option value="">Timezone 03</option>
                                    </select>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <input type="text" class="form-control" id="" placeholder=""><span class="bar"></span>
                                        <label for="">Practice Name</label>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <input type="text" class="form-control" id="" placeholder=""><span class="bar"></span>
                                        <label for="">Practice Type</label>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <input type="text" class="form-control" id="" placeholder=""><span class="bar"></span>
                                        <label for="">Website</label>
                                    </div>
                                </div>
                            </div>

                            <h3 class="font-weight-bold h3Spacing">Contact Information</h3>
                            <div class="form-row">
                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <input type="tel" class="form-control phone-inputmask" id="" placeholder=""><span class="bar"></span>
                                        <label for="">Phone</label>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <input type="tel" class="form-control phone-inputmask" id="" placeholder=""><span class="bar"></span>
                                        <label for="">Fax</label>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <input type="text" class="form-control" id="" placeholder=""><span class="bar"></span>
                                        <label for="">Email</label>
                                    </div>
                                </div>
                            </div>

                            <h3 class="font-weight-bold h3Spacing">Address Information</h3>
                            <div class="form-row">
                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <input type="text" class="form-control" id="" placeholder=""><span class="bar"></span>
                                        <label for="">Street</label>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <input type="text" class="form-control" id="" placeholder=""><span class="bar"></span>
                                        <label for="">City</label>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <input type="text" class="form-control" id="" placeholder=""><span class="bar"></span>
                                        <label for="">State</label>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <input type="text" class="form-control" id="" placeholder=""><span class="bar"></span>
                                        <label for="">Zip</label>
                                    </div>
                                </div>
                            </div>

                            <button class="btn btn-lg mt-4 btn-outline-success col-12 locationinfoUpdate" type="button">Update</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- ============================================================== -->
        <!-- End Container fluid  -->
        <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
</template>

<script>
    export default {
        name: 'pageWraper'

    }
</script>

<style scoped>
</style>